// extracted by mini-css-extract-plugin
export default {"interval":"HeaderInterval_interval__IIGg9","text":"HeaderInterval_text__PBk+-","reset":"HeaderInterval_reset__-vFr+"};